module.exports = __webpack_public_path__ + "img/03.c0b43384.jpg";